export interface AdditionalCharge {
  id: string;
  name: string;
  description: string;
  price: number;
  active: boolean;
}

export let additionalCharges: AdditionalCharge[] = [
  {
    id: 'preferred-frequency',
    name: 'Frecuencia preferida',
    description: 'Reserva de frecuencia preferida para la radio. Permite elegir una frecuencia específica dentro del dial disponible.',
    price: 29.99,
    active: true,
  },
  {
    id: 'premium-domain',
    name: 'Dominio premium',
    description: 'Dominio .com o .fm personalizado para la radio. Incluye configuración DNS y certificado SSL.',
    price: 19.99,
    active: true,
  },
  {
    id: 'extra-space',
    name: 'Espacio adicional',
    description: 'Almacenamiento extra para archivos de audio, imágenes y contenido multimedia de la radio.',
    price: 14.99,
    active: true,
  },
  {
    id: 'app-android',
    name: 'App Android',
    description: 'Aplicación nativa para Android publicada en Google Play Store con branding personalizado de la radio.',
    price: 199.99,
    active: true,
  },
  {
    id: 'app-iphone',
    name: 'App iPhone',
    description: 'Aplicación nativa para iPhone publicada en Apple App Store con branding personalizado de la radio.',
    price: 199.99,
    active: true,
  },
  {
    id: 'app-android-tv',
    name: 'App Android TV',
    description: 'Aplicación para Android TV / Google TV optimizada para pantallas grandes con experiencia de radio en living.',
    price: 149.99,
    active: true,
  },
  {
    id: 'app-fire-tv',
    name: 'App Fire TV',
    description: 'Aplicación para Amazon Fire TV Stick y Fire TV Cube con reproducción en segundo plano.',
    price: 149.99,
    active: false,
  },
  {
    id: 'app-samsung-tv',
    name: 'App Samsung TV',
    description: 'Aplicación para televisores Samsung con Tizen OS, optimizada para experiencia de audio en TV.',
    price: 149.99,
    active: false,
  },
  {
    id: 'app-lg-tv',
    name: 'App LG TV',
    description: 'Aplicación para televisores LG con WebOS, interfaz adaptada a control remoto y pantalla grande.',
    price: 149.99,
    active: false,
  },
  {
    id: 'radio-migration',
    name: 'Migración de radio',
    description: 'Servicio de migración completa de otra plataforma a RadioFrecuenciaWeb. Incluye datos, programación, archivos y configuración.',
    price: 99.99,
    active: true,
  },
  {
    id: 'priority-support',
    name: 'Soporte prioritario',
    description: 'Atención prioritaria con tiempo de respuesta garantizado menor a 2 horas. Incluye canal de chat directo y soporte telefónico.',
    price: 49.99,
    active: true,
  },
];